import React from 'react';
import BilanIconButton from './BilanIconButton';

interface RefusedStatusButtonProps {
  onClick?: (
    ev:
      | React.MouseEvent<HTMLAnchorElement, MouseEvent>
      | React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => void;
}

export default function RefusedStatusButton({ onClick }: RefusedStatusButtonProps) {
  return (
    <BilanIconButton
      aria-label="Ouvrir le bilan refusé"
      iconType="cross"
      onClick={onClick}
      size="xs"
      variant="destructive"
      variantType="primary"
    />
  );
}
